import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer id="links">
        <div className="container-fluid">
          <div className="row">
            <a className="col-md-3 mau">
              <div className="pt-4 pb-4 d-flex justify-content-center">
                SAYA MAU DONASI / WAKAF <img src="assets/right-arrow.png" alt="donasi" />
              </div>
            </a>            
            <a href={ this.props.data.whatsapp } className="col-md-3 wa">
              <div className="pt-4 pb-4 d-flex justify-content-center">
                <img src="assets/whatsapp-logo.png" alt="whatsapp" /> WHATSAPP
              </div>
            </a>
            <a href={ this.props.data.telegram } className="col-md-3 tg">
              <div className="accent-3 pt-4 pb-4 d-flex justify-content-center">
                <img src="assets/telegram.png" alt="telegram" /> TELEGRAM
              </div>
            </a>
            <a href={ this.props.data.website } className="col-md-3 web">
              <div className="pt-4 pb-4 d-flex justify-content-center">
                <img src="assets/grid-world.png" alt="world" /> WEBSITE
              </div>
            </a>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js